import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import { Breadcrumb } from 'semantic-ui-react'
import { rootPath } from 'routes'
import { AdminContainer, MenuContainer, AdminMenuButton } from './styled'
import { supportPath, configPath, prManagementPath, masterDataPath, vendorManagementPath } from 'routes'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'

const Admin = (props) => {
  const { user, history } = props

  useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    if (user) {
      if (user.isAdmin === false) {
        history.replace(rootPath)
      }
    }
  }, [user])

  const MenuButton = (data) => {
    const { title, icon, path } = data
    return (
      <AdminMenuButton onClick={() => history.push(path) }>
        <Icon size='3x' icon={icon} />
        <div style={{ textAlign: 'center' }} className='title'>{title}</div>
      </AdminMenuButton>
    )
  }

  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Admin</div>
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'Admin', content: 'Admin', active: true }
            ]
          }
        />

      </div>
      <MenuContainer>
        <MenuButton title='Support' icon='wrench' path={supportPath} />
        <MenuButton title='PR Management' icon='pencil-ruler' path={prManagementPath} />
        <MenuButton title='Configuration' icon='cogs' path={configPath} />
        <MenuButton title='Master Data' icon='project-diagram' path={masterDataPath} />
        <MenuButton title='Vendor Management' icon='industry' path={vendorManagementPath} />
      </MenuContainer>
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    collapseMenu: state.app.collapseSideMenu,
  })
}

const mapDispatchToProps = {
  toggleSideMenu
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin)
